import { createSlice } from "@reduxjs/toolkit";
import { IHelpersSlice, TCountry } from "@/redux/slices/helpers/types";

export const initialState: IHelpersSlice = {
  countries: [
    {
      name: "United Arab Emirates",
      id: 2,
      iso: "AE",
      calling_code: 971,
      flag_url: "/static/img/flags/checker/United-Arab-Emirates.png",
    },
    {
      name: "Afghanistan",
      id: 3,
      iso: "AF",
      calling_code: 93,
      flag_url: "/static/img/flags/checker/Afghanistan.png",
    },
    {
      name: "Antigua and Barbuda",
      id: 4,
      iso: "AG",
      calling_code: 1268,
      flag_url: "/static/img/flags/checker/Antigua-and-Barbuda.png",
    },
    {
      name: "Anguilla",
      id: 5,
      iso: "AI",
      calling_code: 1264,
      flag_url: "/static/img/flags/checker/Anguilla.png",
    },
    {
      name: "Albania",
      id: 6,
      iso: "AL",
      calling_code: 355,
      flag_url: "/static/img/flags/checker/Albania.png",
    },
    {
      name: "Armenia",
      id: 7,
      iso: "AM",
      calling_code: 374,
      flag_url: "/static/img/flags/checker/Armenia.png",
    },
    {
      name: "Angola",
      id: 8,
      iso: "AO",
      calling_code: 244,
      flag_url: "/static/img/flags/checker/Angola.png",
    },
    {
      name: "Antarctica",
      id: 9,
      iso: "AQ",
      calling_code: 672,
      flag_url: "/static/img/flags/checker/Antarctica.png",
    },
    {
      name: "Argentina",
      id: 10,
      iso: "AR",
      calling_code: 54,
      flag_url: "/static/img/flags/checker/Argentina.png",
    },
    {
      name: "American Samoa",
      id: 11,
      iso: "AS",
      calling_code: 1684,
      flag_url: "/static/img/flags/checker/American-Samoa.png",
    },
    {
      name: "Austria",
      id: 12,
      iso: "AT",
      calling_code: 43,
      flag_url: "/static/img/flags/checker/Austria.png",
    },
    {
      name: "Australia",
      id: 13,
      iso: "AU",
      calling_code: 61,
      flag_url: "/static/img/flags/checker/Australia.png",
    },
    {
      name: "Aruba",
      id: 14,
      iso: "AW",
      calling_code: 297,
      flag_url: "/static/img/flags/checker/Aruba.png",
    },
    {
      name: "Åland Islands",
      id: 15,
      iso: "AX",
      calling_code: 35818,
      flag_url: "/static/img/flags/checker/Aland.png",
    },
    {
      name: "Azerbaijan",
      id: 16,
      iso: "AZ",
      calling_code: 994,
      flag_url: "/static/img/flags/checker/Azerbaijan.png",
    },
    {
      name: "Bosnia and Herzegovina",
      id: 17,
      iso: "BA",
      calling_code: 387,
      flag_url: "/static/img/flags/checker/Bosnia-and-Herzegovina.png",
    },
    {
      name: "Barbados",
      id: 18,
      iso: "BB",
      calling_code: 1246,
      flag_url: "/static/img/flags/checker/Barbados.png",
    },
    {
      name: "Bangladesh",
      id: 19,
      iso: "BD",
      calling_code: 880,
      flag_url: "/static/img/flags/checker/Bangladesh.png",
    },
    {
      name: "Belgium",
      id: 20,
      iso: "BE",
      calling_code: 32,
      flag_url: "/static/img/flags/checker/Belgium.png",
    },
    {
      name: "Burkina Faso",
      id: 21,
      iso: "BF",
      calling_code: 226,
      flag_url: "/static/img/flags/checker/Burkina-Faso.png",
    },
    {
      name: "Bulgaria",
      id: 22,
      iso: "BG",
      calling_code: 359,
      flag_url: "/static/img/flags/checker/Bulgaria.png",
    },
    {
      name: "Bahrain",
      id: 23,
      iso: "BH",
      calling_code: 973,
      flag_url: "/static/img/flags/checker/Bahrain.png",
    },
    {
      name: "Burundi",
      id: 24,
      iso: "BI",
      calling_code: 257,
      flag_url: "/static/img/flags/checker/Burundi.png",
    },
    {
      name: "Benin",
      id: 25,
      iso: "BJ",
      calling_code: 229,
      flag_url: "/static/img/flags/checker/Benin.png",
    },
    {
      name: "Saint Barthélemy",
      id: 26,
      iso: "BL",
      calling_code: 590,
      flag_url: "/static/img/flags/checker/Saint-Barthelemy.png",
    },
    {
      name: "Bermuda",
      id: 27,
      iso: "BM",
      calling_code: 1441,
      flag_url: "/static/img/flags/checker/Bermuda.png",
    },
    {
      name: "Brunei Darussalam",
      id: 28,
      iso: "BN",
      calling_code: 673,
      flag_url: "/static/img/flags/checker/Brunei.png",
    },
    {
      name: "Bolivia",
      id: 29,
      iso: "BO",
      calling_code: 591,
      flag_url: "/static/img/flags/checker/Bolivia.png",
    },
    {
      name: "Bonaire, Sint Eustatius and Saba",
      id: 30,
      iso: "BQ",
      calling_code: 5997,
      flag_url: "/static/img/flags/checker/Netherlands.png",
    },
    {
      name: "Brazil",
      id: 31,
      iso: "BR",
      calling_code: 55,
      flag_url: "/static/img/flags/checker/Brazil.png",
    },
    {
      name: "Bahamas",
      id: 32,
      iso: "BS",
      calling_code: 1242,
      flag_url: "/static/img/flags/checker/Bahamas.png",
    },
    {
      name: "Bhutan",
      id: 33,
      iso: "BT",
      calling_code: 975,
      flag_url: "/static/img/flags/checker/Bhutan.png",
    },
    {
      name: "Bouvet Island",
      id: 34,
      iso: "BV",
      calling_code: 47,
      flag_url: "/static/img/flags/checker/Norway.png",
    },
    {
      name: "Botswana",
      id: 35,
      iso: "BW",
      calling_code: 267,
      flag_url: "/static/img/flags/checker/Botswana.png",
    },
    {
      name: "Belarus",
      id: 36,
      iso: "BY",
      calling_code: 375,
      flag_url: "/static/img/flags/checker/Belarus.png",
    },
    {
      name: "Belize",
      id: 37,
      iso: "BZ",
      calling_code: 501,
      flag_url: "/static/img/flags/checker/Belize.png",
    },
    {
      name: "Canada",
      id: 38,
      iso: "CA",
      calling_code: 1,
      flag_url: "/static/img/flags/checker/Canada.png",
    },
    {
      name: "Cocos (Keeling) Islands",
      id: 39,
      iso: "CC",
      calling_code: 61,
      flag_url: "/static/img/flags/checker/Cocos-Keeling-Islands.png",
    },
    {
      name: "Democratic Republic of the Congo",
      id: 40,
      iso: "CD",
      calling_code: 243,
      flag_url:
        "/static/img/flags/checker/Democratic-Republic-of-the-Congo.png",
    },
    {
      name: "Central African Republic",
      id: 41,
      iso: "CF",
      calling_code: 236,
      flag_url: "/static/img/flags/checker/Central-African-Republic.png",
    },
    {
      name: "Congo",
      id: 42,
      iso: "CG",
      calling_code: 242,
      flag_url: "/static/img/flags/checker/Republic-of-the-Congo.png",
    },
    {
      name: "Switzerland",
      id: 43,
      iso: "CH",
      calling_code: 41,
      flag_url: "/static/img/flags/checker/Switzerland.png",
    },
    {
      name: "Cote dIvoire",
      id: 44,
      iso: "CI",
      calling_code: 225,
      flag_url: "/static/img/flags/checker/Cote-dIvoire.png",
    },
    {
      name: "Cook Islands",
      id: 45,
      iso: "CK",
      calling_code: 682,
      flag_url: "/static/img/flags/checker/Cook-Islands.png",
    },
    {
      name: "Chile",
      id: 46,
      iso: "CL",
      calling_code: 56,
      flag_url: "/static/img/flags/checker/Chile.png",
    },
    {
      name: "Cameroon",
      id: 47,
      iso: "CM",
      calling_code: 237,
      flag_url: "/static/img/flags/checker/Cameroon.png",
    },
    {
      name: "China",
      id: 48,
      iso: "CN",
      calling_code: 86,
      flag_url: "/static/img/flags/checker/China.png",
    },
    {
      name: "Colombia",
      id: 49,
      iso: "CO",
      calling_code: 57,
      flag_url: "/static/img/flags/checker/Colombia.png",
    },
    {
      name: "Costa Rica",
      id: 50,
      iso: "CR",
      calling_code: 506,
      flag_url: "/static/img/flags/checker/Costa-Rica.png",
    },
    {
      name: "Cuba",
      id: 51,
      iso: "CU",
      calling_code: 53,
      flag_url: "/static/img/flags/checker/Cuba.png",
    },
    {
      name: "Cape Verde",
      id: 52,
      iso: "CV",
      calling_code: 238,
      flag_url: "/static/img/flags/checker/Cape-Verde.png",
    },
    {
      name: "Curaçao",
      id: 53,
      iso: "CW",
      calling_code: 599,
      flag_url: "/static/img/flags/checker/Curacao.png",
    },
    {
      name: "Christmas Island",
      id: 54,
      iso: "CX",
      calling_code: 61,
      flag_url: "/static/img/flags/checker/Christmas-Island.png",
    },
    {
      name: "Cyprus",
      id: 55,
      iso: "CY",
      calling_code: 357,
      flag_url: "/static/img/flags/checker/Cyprus.png",
    },
    {
      name: "Czech Republic",
      id: 56,
      iso: "CZ",
      calling_code: 420,
      flag_url: "/static/img/flags/checker/Czech-Republic.png",
    },
    {
      name: "Germany",
      id: 57,
      iso: "DE",
      calling_code: 49,
      flag_url: "/static/img/flags/checker/Germany.png",
    },
    {
      name: "Djibouti",
      id: 58,
      iso: "DJ",
      calling_code: 253,
      flag_url: "/static/img/flags/checker/Djibouti.png",
    },
    {
      name: "Denmark",
      id: 59,
      iso: "DK",
      calling_code: 45,
      flag_url: "/static/img/flags/checker/Denmark.png",
    },
    {
      name: "Dominica",
      id: 60,
      iso: "DM",
      calling_code: 1767,
      flag_url: "/static/img/flags/checker/Dominica.png",
    },
    {
      name: "Dominican Republic",
      id: 61,
      iso: "DO",
      calling_code: 1809,
      flag_url: "/static/img/flags/checker/Dominican-Republic.png",
    },
    {
      name: "Algeria",
      id: 62,
      iso: "DZ",
      calling_code: 213,
      flag_url: "/static/img/flags/checker/Algeria.png",
    },
    {
      name: "Ecuador",
      id: 63,
      iso: "EC",
      calling_code: 593,
      flag_url: "/static/img/flags/checker/Ecuador.png",
    },
    {
      name: "Estonia",
      id: 64,
      iso: "EE",
      calling_code: 372,
      flag_url: "/static/img/flags/checker/Estonia.png",
    },
    {
      name: "Egypt",
      id: 65,
      iso: "EG",
      calling_code: 20,
      flag_url: "/static/img/flags/checker/Egypt.png",
    },
    {
      name: "Western Sahara",
      id: 66,
      iso: "EH",
      calling_code: 212,
      flag_url: "/static/img/flags/checker/Western-Sahara.png",
    },
    {
      name: "Eritrea",
      id: 67,
      iso: "ER",
      calling_code: 291,
      flag_url: "/static/img/flags/checker/Eritrea.png",
    },
    {
      name: "Spain",
      id: 68,
      iso: "ES",
      calling_code: 34,
      flag_url: "/static/img/flags/checker/Spain.png",
    },
    {
      name: "Ethiopia",
      id: 69,
      iso: "ET",
      calling_code: 251,
      flag_url: "/static/img/flags/checker/Ethiopia.png",
    },
    {
      name: "Finland",
      id: 70,
      iso: "FI",
      calling_code: 358,
      flag_url: "/static/img/flags/checker/Finland.png",
    },
    {
      name: "Fiji",
      id: 71,
      iso: "FJ",
      calling_code: 679,
      flag_url: "/static/img/flags/checker/Fiji.png",
    },
    {
      name: "Falkland Islands",
      id: 72,
      iso: "FK",
      calling_code: 500,
      flag_url: "/static/img/flags/checker/Falkland-Islands.png",
    },
    {
      name: "Micronesia",
      id: 73,
      iso: "FM",
      calling_code: 691,
      flag_url: "/static/img/flags/checker/Micronesia.png",
    },
    {
      name: "Faroe Islands",
      id: 74,
      iso: "FO",
      calling_code: 298,
      flag_url: "/static/img/flags/checker/Faroes.png",
    },
    {
      name: "France",
      id: 75,
      iso: "FR",
      calling_code: 33,
      flag_url: "/static/img/flags/checker/France.png",
    },
    {
      name: "Gabon",
      id: 76,
      iso: "GA",
      calling_code: 241,
      flag_url: "/static/img/flags/checker/Gabon.png",
    },
    {
      name: "United Kingdom",
      id: 77,
      iso: "GB",
      calling_code: 44,
      flag_url: "/static/img/flags/checker/United-Kingdom.png",
    },
    {
      name: "Grenada",
      id: 78,
      iso: "GD",
      calling_code: 1473,
      flag_url: "/static/img/flags/checker/Grenada.png",
    },
    {
      name: "Georgia",
      id: 79,
      iso: "GE",
      calling_code: 995,
      flag_url: "/static/img/flags/checker/Georgia.png",
    },
    {
      name: "French Guiana",
      id: 80,
      iso: "GF",
      calling_code: 596,
      flag_url: "/static/img/flags/checker/France.png",
    },
    {
      name: "Guernsey",
      id: 81,
      iso: "GG",
      calling_code: 441481,
      flag_url: "/static/img/flags/checker/Guernsey.png",
    },
    {
      name: "Ghana",
      id: 82,
      iso: "GH",
      calling_code: 233,
      flag_url: "/static/img/flags/checker/Ghana.png",
    },
    {
      name: "Gibraltar",
      id: 83,
      iso: "GI",
      calling_code: 350,
      flag_url: "/static/img/flags/checker/Gibraltar.png",
    },
    {
      name: "Greenland",
      id: 84,
      iso: "GL",
      calling_code: 299,
      flag_url: "/static/img/flags/checker/Greenland.png",
    },
    {
      name: "Gambia",
      id: 85,
      iso: "GM",
      calling_code: 220,
      flag_url: "/static/img/flags/checker/Gambia.png",
    },
    {
      name: "Guinea",
      id: 86,
      iso: "GN",
      calling_code: 224,
      flag_url: "/static/img/flags/checker/Guinea.png",
    },
    {
      name: "Guadeloupe",
      id: 87,
      iso: "GP",
      calling_code: 590,
      flag_url: "/static/img/flags/checker/France.png",
    },
    {
      name: "Equatorial Guinea",
      id: 88,
      iso: "GQ",
      calling_code: 240,
      flag_url: "/static/img/flags/checker/Equatorial-Guinea.png",
    },
    {
      name: "Greece",
      id: 89,
      iso: "GR",
      calling_code: 30,
      flag_url: "/static/img/flags/checker/Greece.png",
    },
    {
      name: "South Georgia and the South Sandwich Islands",
      id: 90,
      iso: "GS",
      calling_code: 500,
      flag_url:
        "/static/img/flags/checker/South-Georgia-and-the-South-Sandwich-Islands.png",
    },
    {
      name: "Guatemala",
      id: 91,
      iso: "GT",
      calling_code: 502,
      flag_url: "/static/img/flags/checker/Guatemala.png",
    },
    {
      name: "Guam",
      id: 92,
      iso: "GU",
      calling_code: 1671,
      flag_url: "/static/img/flags/checker/Guam.png",
    },
    {
      name: "Guinea-Bissau",
      id: 93,
      iso: "GW",
      calling_code: 245,
      flag_url: "/static/img/flags/checker/Guinea-Bissau.png",
    },
    {
      name: "Guyana",
      id: 94,
      iso: "GY",
      calling_code: 592,
      flag_url: "/static/img/flags/checker/Guyana.png",
    },
    {
      name: "Hong Kong",
      id: 95,
      iso: "HK",
      calling_code: 852,
      flag_url: "/static/img/flags/checker/Hong-Kong.png",
    },
    {
      name: "Heard Island and McDonald Islands",
      id: 96,
      iso: "HM",
      calling_code: 614,
      flag_url: "/static/img/flags/checker/Australia.png",
    },
    {
      name: "Honduras",
      id: 97,
      iso: "HN",
      calling_code: 504,
      flag_url: "/static/img/flags/checker/Honduras.png",
    },
    {
      name: "Croatia",
      id: 98,
      iso: "HR",
      calling_code: 385,
      flag_url: "/static/img/flags/checker/Croatia.png",
    },
    {
      name: "Haiti",
      id: 99,
      iso: "HT",
      calling_code: 509,
      flag_url: "/static/img/flags/checker/Haiti.png",
    },
    {
      name: "Hungary",
      id: 100,
      iso: "HU",
      calling_code: 36,
      flag_url: "/static/img/flags/checker/Hungary.png",
    },
    {
      name: "Indonesia",
      id: 101,
      iso: "ID",
      calling_code: 62,
      flag_url: "/static/img/flags/checker/Indonesia.png",
    },
    {
      name: "Ireland",
      id: 102,
      iso: "IE",
      calling_code: 353,
      flag_url: "/static/img/flags/checker/Ireland.png",
    },
    {
      name: "Israel",
      id: 103,
      iso: "IL",
      calling_code: 972,
      flag_url: "/static/img/flags/checker/Israel.png",
    },
    {
      name: "Isle of Man",
      id: 104,
      iso: "IM",
      calling_code: 441624,
      flag_url: "/static/img/flags/checker/Isle-of-Man.png",
    },
    {
      name: "India",
      id: 105,
      iso: "IN",
      calling_code: 91,
      flag_url: "/static/img/flags/checker/India.png",
    },
    {
      name: "British Indian Ocean Territory",
      id: 106,
      iso: "IO",
      calling_code: 246,
      flag_url: "/static/img/flags/checker/United-Kingdom.png",
    },
    {
      name: "Iraq",
      id: 107,
      iso: "IQ",
      calling_code: 964,
      flag_url: "/static/img/flags/checker/Iraq.png",
    },
    {
      name: "Iran",
      id: 108,
      iso: "IR",
      calling_code: 98,
      flag_url: "/static/img/flags/checker/Iran.png",
    },
    {
      name: "Iceland",
      id: 109,
      iso: "IS",
      calling_code: 354,
      flag_url: "/static/img/flags/checker/Iceland.png",
    },
    {
      name: "Italy",
      id: 110,
      iso: "IT",
      calling_code: 39,
      flag_url: "/static/img/flags/checker/Italy.png",
    },
    {
      name: "Jersey",
      id: 111,
      iso: "JE",
      calling_code: 441534,
      flag_url: "/static/img/flags/checker/Jersey.png",
    },
    {
      name: "Jamaica",
      id: 112,
      iso: "JM",
      calling_code: 1876,
      flag_url: "/static/img/flags/checker/Jamaica.png",
    },
    {
      name: "Jordan",
      id: 113,
      iso: "JO",
      calling_code: 962,
      flag_url: "/static/img/flags/checker/Jordan.png",
    },
    {
      name: "Japan",
      id: 114,
      iso: "JP",
      calling_code: 81,
      flag_url: "/static/img/flags/checker/Japan.png",
    },
    {
      name: "Kenya",
      id: 115,
      iso: "KE",
      calling_code: 254,
      flag_url: "/static/img/flags/checker/Kenya.png",
    },
    {
      name: "Kyrgyzstan",
      id: 116,
      iso: "KG",
      calling_code: 996,
      flag_url: "/static/img/flags/checker/Kyrgyzstan.png",
    },
    {
      name: "Cambodia",
      id: 117,
      iso: "KH",
      calling_code: 855,
      flag_url: "/static/img/flags/checker/Cambodia.png",
    },
    {
      name: "Kiribati",
      id: 118,
      iso: "KI",
      calling_code: 686,
      flag_url: "/static/img/flags/checker/Kiribati.png",
    },
    {
      name: "Comoros",
      id: 119,
      iso: "KM",
      calling_code: 269,
      flag_url: "/static/img/flags/checker/Comoros.png",
    },
    {
      name: "Saint Kitts and Nevis",
      id: 120,
      iso: "KN",
      calling_code: 1869,
      flag_url: "/static/img/flags/checker/Saint-Kitts-and-Nevis.png",
    },
    {
      name: "North Korea",
      id: 121,
      iso: "KP",
      calling_code: 850,
      flag_url: "/static/img/flags/checker/North-Korea.png",
    },
    {
      name: "South Korea",
      id: 122,
      iso: "KR",
      calling_code: 82,
      flag_url: "/static/img/flags/checker/South-Korea.png",
    },
    {
      name: "Kuwait",
      id: 123,
      iso: "KW",
      calling_code: 965,
      flag_url: "/static/img/flags/checker/Kuwait.png",
    },
    {
      name: "Cayman Islands",
      id: 124,
      iso: "KY",
      calling_code: 1345,
      flag_url: "/static/img/flags/checker/Cayman-Islands.png",
    },
    {
      name: "Kazakhstan",
      id: 125,
      iso: "KZ",
      calling_code: 7,
      flag_url: "/static/img/flags/checker/Kazakhstan.png",
    },
    {
      name: "Laos",
      id: 126,
      iso: "LA",
      calling_code: 856,
      flag_url: "/static/img/flags/checker/Laos.png",
    },
    {
      name: "Lebanon",
      id: 127,
      iso: "LB",
      calling_code: 961,
      flag_url: "/static/img/flags/checker/Lebanon.png",
    },
    {
      name: "Saint Lucia",
      id: 128,
      iso: "LC",
      calling_code: 1758,
      flag_url: "/static/img/flags/checker/Saint-Lucia.png",
    },
    {
      name: "Liechtenstein",
      id: 129,
      iso: "LI",
      calling_code: 423,
      flag_url: "/static/img/flags/checker/Liechtenstein.png",
    },
    {
      name: "Sri Lanka",
      id: 130,
      iso: "LK",
      calling_code: 94,
      flag_url: "/static/img/flags/checker/Sri-Lanka.png",
    },
    {
      name: "Liberia",
      id: 131,
      iso: "LR",
      calling_code: 231,
      flag_url: "/static/img/flags/checker/Liberia.png",
    },
    {
      name: "Lesotho",
      id: 132,
      iso: "LS",
      calling_code: 266,
      flag_url: "/static/img/flags/checker/Lesotho.png",
    },
    {
      name: "Lithuania",
      id: 133,
      iso: "LT",
      calling_code: 370,
      flag_url: "/static/img/flags/checker/Lithuania.png",
    },
    {
      name: "Luxembourg",
      id: 134,
      iso: "LU",
      calling_code: 352,
      flag_url: "/static/img/flags/checker/Luxembourg.png",
    },
    {
      name: "Latvia",
      id: 135,
      iso: "LV",
      calling_code: 371,
      flag_url: "/static/img/flags/checker/Latvia.png",
    },
    {
      name: "Libya",
      id: 136,
      iso: "LY",
      calling_code: 218,
      flag_url: "/static/img/flags/checker/Libya.png",
    },
    {
      name: "Morocco",
      id: 137,
      iso: "MA",
      calling_code: 212,
      flag_url: "/static/img/flags/checker/Morocco.png",
    },
    {
      name: "Monaco",
      id: 138,
      iso: "MC",
      calling_code: 377,
      flag_url: "/static/img/flags/checker/Monaco.png",
    },
    {
      name: "Moldova",
      id: 139,
      iso: "MD",
      calling_code: 373,
      flag_url: "/static/img/flags/checker/Moldova.png",
    },
    {
      name: "Montenegro",
      id: 140,
      iso: "ME",
      calling_code: 382,
      flag_url: "/static/img/flags/checker/Montenegro.png",
    },
    {
      name: "Saint Martin",
      id: 141,
      iso: "MF",
      calling_code: 590,
      flag_url: "/static/img/flags/checker/Saint-Martin.png",
    },
    {
      name: "Madagascar",
      id: 142,
      iso: "MG",
      calling_code: 261,
      flag_url: "/static/img/flags/checker/Madagascar.png",
    },
    {
      name: "Marshall Islands",
      id: 143,
      iso: "MH",
      calling_code: 692,
      flag_url: "/static/img/flags/checker/Marshall-Islands.png",
    },
    {
      name: "Macedonia",
      id: 144,
      iso: "MK",
      calling_code: 389,
      flag_url: "/static/img/flags/checker/Macedonia.png",
    },
    {
      name: "Mali",
      id: 145,
      iso: "ML",
      calling_code: 223,
      flag_url: "/static/img/flags/checker/Mali.png",
    },
    {
      name: "Myanmar",
      id: 146,
      iso: "MM",
      calling_code: 95,
      flag_url: "/static/img/flags/checker/Myanmar.png",
    },
    {
      name: "Mongolia",
      id: 147,
      iso: "MN",
      calling_code: 976,
      flag_url: "/static/img/flags/checker/Mongolia.png",
    },
    {
      name: "Macau",
      id: 148,
      iso: "MO",
      calling_code: 853,
      flag_url: "/static/img/flags/checker/Macau.png",
    },
    {
      name: "Northern Mariana Islands",
      id: 149,
      iso: "MP",
      calling_code: 1670,
      flag_url: "/static/img/flags/checker/Northern-Mariana-Islands.png",
    },
    {
      name: "Martinique",
      id: 150,
      iso: "MQ",
      calling_code: 596,
      flag_url: "/static/img/flags/checker/Martinique.png",
    },
    {
      name: "Mauritania",
      id: 151,
      iso: "MR",
      calling_code: 222,
      flag_url: "/static/img/flags/checker/Mauritania.png",
    },
    {
      name: "Montserrat",
      id: 152,
      iso: "MS",
      calling_code: 1664,
      flag_url: "/static/img/flags/checker/Montserrat.png",
    },
    {
      name: "Malta",
      id: 153,
      iso: "MT",
      calling_code: 356,
      flag_url: "/static/img/flags/checker/Malta.png",
    },
    {
      name: "Mauritius",
      id: 154,
      iso: "MU",
      calling_code: 230,
      flag_url: "/static/img/flags/checker/Mauritius.png",
    },
    {
      name: "Maldives",
      id: 155,
      iso: "MV",
      calling_code: 960,
      flag_url: "/static/img/flags/checker/Maldives.png",
    },
    {
      name: "Malawi",
      id: 156,
      iso: "MW",
      calling_code: 265,
      flag_url: "/static/img/flags/checker/Malawi.png",
    },
    {
      name: "Mexico",
      id: 157,
      iso: "MX",
      calling_code: 52,
      flag_url: "/static/img/flags/checker/Mexico.png",
    },
    {
      name: "Malaysia",
      id: 158,
      iso: "MY",
      calling_code: 60,
      flag_url: "/static/img/flags/checker/Malaysia.png",
    },
    {
      name: "Mozambique",
      id: 159,
      iso: "MZ",
      calling_code: 258,
      flag_url: "/static/img/flags/checker/Mozambique.png",
    },
    {
      name: "Namibia",
      id: 160,
      iso: "NA",
      calling_code: 264,
      flag_url: "/static/img/flags/checker/Namibia.png",
    },
    {
      name: "New Caledonia",
      id: 161,
      iso: "NC",
      calling_code: 687,
      flag_url: "/static/img/flags/checker/New-Caledonia.png",
    },
    {
      name: "Niger",
      id: 162,
      iso: "NE",
      calling_code: 227,
      flag_url: "/static/img/flags/checker/Niger.png",
    },
    {
      name: "Norfolk Island",
      id: 163,
      iso: "NF",
      calling_code: 672,
      flag_url: "/static/img/flags/checker/Norfolk-Island.png",
    },
    {
      name: "Nigeria",
      id: 164,
      iso: "NG",
      calling_code: 234,
      flag_url: "/static/img/flags/checker/Nigeria.png",
    },
    {
      name: "Nicaragua",
      id: 165,
      iso: "NI",
      calling_code: 505,
      flag_url: "/static/img/flags/checker/Nicaragua.png",
    },
    {
      name: "Netherlands",
      id: 166,
      iso: "NL",
      calling_code: 31,
      flag_url: "/static/img/flags/checker/Netherlands.png",
    },
    {
      name: "Norway",
      id: 167,
      iso: "NO",
      calling_code: 47,
      flag_url: "/static/img/flags/checker/Norway.png",
    },
    {
      name: "Nepal",
      id: 168,
      iso: "NP",
      calling_code: 977,
      flag_url: "/static/img/flags/checker/Nepal.png",
    },
    {
      name: "Nauru",
      id: 169,
      iso: "NR",
      calling_code: 674,
      flag_url: "/static/img/flags/checker/Nauru.png",
    },
    {
      name: "Niue",
      id: 170,
      iso: "NU",
      calling_code: 683,
      flag_url: "/static/img/flags/checker/Niue.png",
    },
    {
      name: "New Zealand",
      id: 171,
      iso: "NZ",
      calling_code: 64,
      flag_url: "/static/img/flags/checker/New-Zealand.png",
    },
    {
      name: "Oman",
      id: 172,
      iso: "OM",
      calling_code: 968,
      flag_url: "/static/img/flags/checker/Oman.png",
    },
    {
      name: "Panama",
      id: 173,
      iso: "PA",
      calling_code: 507,
      flag_url: "/static/img/flags/checker/Panama.png",
    },
    {
      name: "Peru",
      id: 174,
      iso: "PE",
      calling_code: 51,
      flag_url: "/static/img/flags/checker/Peru.png",
    },
    {
      name: "French Polynesia",
      id: 175,
      iso: "PF",
      calling_code: 689,
      flag_url: "/static/img/flags/checker/French-Polynesia.png",
    },
    {
      name: "Papua New Guinea",
      id: 176,
      iso: "PG",
      calling_code: 675,
      flag_url: "/static/img/flags/checker/Papua-New-Guinea.png",
    },
    {
      name: "Philippines",
      id: 177,
      iso: "PH",
      calling_code: 63,
      flag_url: "/static/img/flags/checker/Philippines.png",
    },
    {
      name: "Pakistan",
      id: 178,
      iso: "PK",
      calling_code: 92,
      flag_url: "/static/img/flags/checker/Pakistan.png",
    },
    {
      name: "Poland",
      id: 179,
      iso: "PL",
      calling_code: 48,
      flag_url: "/static/img/flags/checker/Poland.png",
    },
    {
      name: "Saint Pierre and Miquelon",
      id: 180,
      iso: "PM",
      calling_code: 508,
      flag_url: "/static/img/flags/checker/France.png",
    },
    {
      name: "Pitcairn",
      id: 181,
      iso: "PN",
      calling_code: 64,
      flag_url: "/static/img/flags/checker/Pitcairn-Islands.png",
    },
    {
      name: "Puerto Rico",
      id: 182,
      iso: "PR",
      calling_code: 1787,
      flag_url: "/static/img/flags/checker/Puerto-Rico.png",
    },
    {
      name: "Palestine",
      id: 183,
      iso: "PS",
      calling_code: 970,
      flag_url: "/static/img/flags/checker/Palestine.png",
    },
    {
      name: "Portugal",
      id: 184,
      iso: "PT",
      calling_code: 351,
      flag_url: "/static/img/flags/checker/Portugal.png",
    },
    {
      name: "Palau",
      id: 185,
      iso: "PW",
      calling_code: 680,
      flag_url: "/static/img/flags/checker/Palau.png",
    },
    {
      name: "Paraguay",
      id: 186,
      iso: "PY",
      calling_code: 595,
      flag_url: "/static/img/flags/checker/Paraguay.png",
    },
    {
      name: "Qatar",
      id: 187,
      iso: "QA",
      calling_code: 974,
      flag_url: "/static/img/flags/checker/Qatar.png",
    },
    {
      name: "Reunion",
      id: 188,
      iso: "RE",
      calling_code: 262,
      flag_url: "/static/img/flags/checker/France.png",
    },
    {
      name: "Romania",
      id: 189,
      iso: "RO",
      calling_code: 40,
      flag_url: "/static/img/flags/checker/Romania.png",
    },
    {
      name: "Serbia",
      id: 190,
      iso: "RS",
      calling_code: 381,
      flag_url: "/static/img/flags/checker/Serbia.png",
    },
    {
      name: "Russian Federation",
      id: 191,
      iso: "RU",
      calling_code: 7,
      flag_url: "/static/img/flags/checker/Russia.png",
    },
    {
      name: "Rwanda",
      id: 192,
      iso: "RW",
      calling_code: 250,
      flag_url: "/static/img/flags/checker/Rwanda.png",
    },
    {
      name: "Saudi Arabia",
      id: 193,
      iso: "SA",
      calling_code: 966,
      flag_url: "/static/img/flags/checker/Saudi-Arabia.png",
    },
    {
      name: "Solomon Islands",
      id: 194,
      iso: "SB",
      calling_code: 677,
      flag_url: "/static/img/flags/checker/Solomon-Islands.png",
    },
    {
      name: "Seychelles",
      id: 195,
      iso: "SC",
      calling_code: 248,
      flag_url: "/static/img/flags/checker/Seychelles.png",
    },
    {
      name: "Sudan",
      id: 196,
      iso: "SD",
      calling_code: 249,
      flag_url: "/static/img/flags/checker/Sudan.png",
    },
    {
      name: "Sweden",
      id: 197,
      iso: "SE",
      calling_code: 46,
      flag_url: "/static/img/flags/checker/Sweden.png",
    },
    {
      name: "Singapore",
      id: 198,
      iso: "SG",
      calling_code: 65,
      flag_url: "/static/img/flags/checker/Singapore.png",
    },
    {
      name: "Saint Helena, Ascension and Tristan da Cunha",
      id: 199,
      iso: "SH",
      calling_code: 290,
      flag_url: "/static/img/flags/checker/Saint-Helena.png",
    },
    {
      name: "Slovenia",
      id: 200,
      iso: "SI",
      calling_code: 386,
      flag_url: "/static/img/flags/checker/Slovenia.png",
    },
    {
      name: "Svalbard and Jan Mayen",
      id: 201,
      iso: "SJ",
      calling_code: 4779,
      flag_url: "/static/img/flags/checker/Norway.png",
    },
    {
      name: "Slovakia",
      id: 202,
      iso: "SK",
      calling_code: 421,
      flag_url: "/static/img/flags/checker/Slovakia.png",
    },
    {
      name: "Sierra Leone",
      id: 203,
      iso: "SL",
      calling_code: 232,
      flag_url: "/static/img/flags/checker/Sierra-Leone.png",
    },
    {
      name: "San Marino",
      id: 204,
      iso: "SM",
      calling_code: 378,
      flag_url: "/static/img/flags/checker/San-Marino.png",
    },
    {
      name: "Senegal",
      id: 205,
      iso: "SN",
      calling_code: 221,
      flag_url: "/static/img/flags/checker/Senegal.png",
    },
    {
      name: "Somalia",
      id: 206,
      iso: "SO",
      calling_code: 252,
      flag_url: "/static/img/flags/checker/Somalia.png",
    },
    {
      name: "Suriname",
      id: 207,
      iso: "SR",
      calling_code: 597,
      flag_url: "/static/img/flags/checker/Suriname.png",
    },
    {
      name: "South Sudan",
      id: 208,
      iso: "SS",
      calling_code: 211,
      flag_url: "/static/img/flags/checker/South-Sudan.png",
    },
    {
      name: "Sao Tome and Principe",
      id: 209,
      iso: "ST",
      calling_code: 239,
      flag_url: "/static/img/flags/checker/Sao-Tome-and-Principe.png",
    },
    {
      name: "El Salvador",
      id: 210,
      iso: "SV",
      calling_code: 503,
      flag_url: "/static/img/flags/checker/El-Salvador.png",
    },
    {
      name: "Sint Maarten",
      id: 211,
      iso: "SX",
      calling_code: 1721,
      flag_url: "/static/img/flags/checker/Netherlands.png",
    },
    {
      name: "Syria",
      id: 212,
      iso: "SY",
      calling_code: 963,
      flag_url: "/static/img/flags/checker/Syria.png",
    },
    {
      name: "Swaziland",
      id: 213,
      iso: "SZ",
      calling_code: 268,
      flag_url: "/static/img/flags/checker/Swaziland.png",
    },
    {
      name: "Turks and Caicos Islands",
      id: 214,
      iso: "TC",
      calling_code: 1649,
      flag_url: "/static/img/flags/checker/Turks-and-Caicos-Islands.png",
    },
    {
      name: "Chad",
      id: 215,
      iso: "TD",
      calling_code: 235,
      flag_url: "/static/img/flags/checker/Chad.png",
    },
    {
      name: "French Southern Territories",
      id: 216,
      iso: "TF",
      calling_code: 262,
      flag_url: "/static/img/flags/checker/French-Southern-Territories.png",
    },
    {
      name: "Togo",
      id: 217,
      iso: "TG",
      calling_code: 228,
      flag_url: "/static/img/flags/checker/Togo.png",
    },
    {
      name: "Thailand",
      id: 218,
      iso: "TH",
      calling_code: 66,
      flag_url: "/static/img/flags/checker/Thailand.png",
    },
    {
      name: "Tajikistan",
      id: 219,
      iso: "TJ",
      calling_code: 992,
      flag_url: "/static/img/flags/checker/Tajikistan.png",
    },
    {
      name: "Tokelau",
      id: 220,
      iso: "TK",
      calling_code: 690,
      flag_url: "/static/img/flags/checker/Tokelau.png",
    },
    {
      name: "East Timor",
      id: 221,
      iso: "TL",
      calling_code: 670,
      flag_url: "/static/img/flags/checker/East-Timor.png",
    },
    {
      name: "Turkmenistan",
      id: 222,
      iso: "TM",
      calling_code: 993,
      flag_url: "/static/img/flags/checker/Turkmenistan.png",
    },
    {
      name: "Tunisia",
      id: 223,
      iso: "TN",
      calling_code: 216,
      flag_url: "/static/img/flags/checker/Tunisia.png",
    },
    {
      name: "Tonga",
      id: 224,
      iso: "TO",
      calling_code: 676,
      flag_url: "/static/img/flags/checker/Tonga.png",
    },
    {
      name: "Turkey",
      id: 225,
      iso: "TR",
      calling_code: 90,
      flag_url: "/static/img/flags/checker/Turkey.png",
    },
    {
      name: "Trinidad and Tobago",
      id: 226,
      iso: "TT",
      calling_code: 1868,
      flag_url: "/static/img/flags/checker/Trinidad-and-Tobago.png",
    },
    {
      name: "Tuvalu",
      id: 227,
      iso: "TV",
      calling_code: 688,
      flag_url: "/static/img/flags/checker/Tuvalu.png",
    },
    {
      name: "Taiwan",
      id: 228,
      iso: "TW",
      calling_code: 886,
      flag_url: "/static/img/flags/checker/Taiwan.png",
    },
    {
      name: "Tanzania",
      id: 229,
      iso: "TZ",
      calling_code: 255,
      flag_url: "/static/img/flags/checker/Tanzania.png",
    },
    {
      name: "Ukraine",
      id: 230,
      iso: "UA",
      calling_code: 380,
      flag_url: "/static/img/flags/checker/Ukraine.png",
    },
    {
      name: "Uganda",
      id: 231,
      iso: "UG",
      calling_code: 256,
      flag_url: "/static/img/flags/checker/Uganda.png",
    },
    {
      name: "United States Minor Outlying Islands",
      id: 232,
      iso: "UM",
      calling_code: 1,
      flag_url: "/static/img/flags/checker/United-States.png",
    },
    {
      name: "United States",
      id: 233,
      iso: "US",
      calling_code: 1,
      flag_url: "/static/img/flags/checker/United-States.png",
    },
    {
      name: "Uruguay",
      id: 234,
      iso: "UY",
      calling_code: 598,
      flag_url: "/static/img/flags/checker/Uruguay.png",
    },
    {
      name: "Uzbekistan",
      id: 235,
      iso: "UZ",
      calling_code: 998,
      flag_url: "/static/img/flags/checker/Uzbekistan.png",
    },
    {
      name: "Vatican City",
      id: 236,
      iso: "VA",
      calling_code: 379,
      flag_url: "/static/img/flags/checker/Vatican-City.png",
    },
    {
      name: "Saint Vincent and the Grenadines",
      id: 237,
      iso: "VC",
      calling_code: 1784,
      flag_url:
        "/static/img/flags/checker/Saint-Vincent-and-the-Grenadines.png",
    },
    {
      name: "Venezuela",
      id: 238,
      iso: "VE",
      calling_code: 58,
      flag_url: "/static/img/flags/checker/Venezuela.png",
    },
    {
      name: "British Virgin Islands",
      id: 239,
      iso: "VG",
      calling_code: 1284,
      flag_url: "/static/img/flags/checker/British-Virgin-Islands.png",
    },
    {
      name: "US Virgin Islands",
      id: 240,
      iso: "VI",
      calling_code: 1340,
      flag_url: "/static/img/flags/checker/US-Virgin-Islands.png",
    },
    {
      name: "Vietnam",
      id: 241,
      iso: "VN",
      calling_code: 84,
      flag_url: "/static/img/flags/checker/Vietnam.png",
    },
    {
      name: "Vanuatu",
      id: 242,
      iso: "VU",
      calling_code: 678,
      flag_url: "/static/img/flags/checker/Vanuatu.png",
    },
    {
      name: "Wallis and Futuna",
      id: 243,
      iso: "WF",
      calling_code: 681,
      flag_url: "/static/img/flags/checker/Wallis-And-Futuna.png",
    },
    {
      name: "Samoa",
      id: 244,
      iso: "WS",
      calling_code: 685,
      flag_url: "/static/img/flags/checker/Samoa.png",
    },
    {
      name: "Yemen",
      id: 245,
      iso: "YE",
      calling_code: 967,
      flag_url: "/static/img/flags/checker/Yemen.png",
    },
    {
      name: "Mayotte",
      id: 246,
      iso: "YT",
      calling_code: 262,
      flag_url: "/static/img/flags/checker/Mayotte.png",
    },
    {
      name: "South Africa",
      id: 247,
      iso: "ZA",
      calling_code: 27,
      flag_url: "/static/img/flags/checker/South-Africa.png",
    },
    {
      name: "Zambia",
      id: 248,
      iso: "ZM",
      calling_code: 260,
      flag_url: "/static/img/flags/checker/Zambia.png",
    },
    {
      name: "Zimbabwe",
      id: 249,
      iso: "ZW",
      calling_code: 263,
      flag_url: "/static/img/flags/checker/Zimbabwe.png",
    },
    {
      name: "Andorra",
      id: 250,
      iso: "AD",
      calling_code: 376,
      flag_url: "/static/img/flags/checker/Andorra.png",
    },
    {
      name: "Netherlands Antilles",
      id: 259,
      iso: "AN",
      calling_code: 599,
      flag_url: "/static/img/flags/checker/Unknown.png",
    },
  ],
};

export const helpersSlice = createSlice({
  name: "helpersSlice",
  initialState,
  reducers: {},
});

export default helpersSlice.reducer;
